module.exports = __webpack_public_path__ + "diogo_pastorello--6e49fc3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/diogo_pastorello.jpg
// module id = 160
// module chunks = 0